import { NgModule } from '@angular/core';
import { NewSearchPage } from '@app/new-search/new-search.page';
import { NewSearchRoutingModule } from '@app/new-search/new-search-routing.module';
import { NewSearchBaseModule } from './shared/new-search-base.module';
import { CommonModule } from '@angular/common';
import { SearchSharedModule } from '@search/shared/search-shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { SharedModule } from '@shared/shared.module';
import { SharedProductModule } from '@app/shared-product/shared-product.module';

@NgModule({
  declarations: [NewSearchPage],
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SharedModule,
    SearchSharedModule,
    ReactiveFormsModule,
    NewSearchBaseModule,
    NewSearchRoutingModule,
    SharedProductModule,
  ],
})
export class NewSearchModule {}
